<template>
  <div class="read_message">
    <breadcrumb
      :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'消息中心',src:'/message'},{name:msgDetail.name}]"
    ></breadcrumb>
    <div class="read_message-wrap">
      <div class="read_message-contain">
        <div class="read_message-title">{{msgDetail.name}}</div>
        <div class="read_message-detail_wrap">
          <div class="read_message-time">
            <div class="read_message-table_top" v-if="msgDetail.top">置顶</div>
            <div class="read_message-table_urgent" v-if="msgDetail.urgent">加急</div>
            {{(msgDetail.updateTime||msgDetail.createTime)|timeFilter}}
          </div>
          <div class="read_message-detail" v-html="msgDetail.content"></div>
					<div class="read_message-file_list">
          <div v-for="(item,index) in fileList" :key="index" class="read_message-file_item">
 <a :href="item.path" :download="item.name">
                <font-awesome-icon
                  style="color:#F0722B;margin-right:10px"
                  :icon="['fas', 'download']"
                />{{item.name}}
              </a>
          </div>
        </div>
          <div class="read_message-read unread">
            未读（{{unRead.length}}人）：
            <div class="read_message-read_list">
              <div
                v-for="item in unRead"
                class="read_message-read_item"
                :key="item.id"
              >{{item.userName}}</div>
            </div>
          </div>
					<div class="read_message-read read">
            已读（{{isRead.length}}人）：
            <div class="read_message-read_list">
              <div
                v-for="item in isRead"
                class="read_message-read_item"
                :key="item.id"
              >{{item.userName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
export default {
  components: {
    breadcrumb
  },
  filters: {
    timeFilter(value) {
      if (value) {
        return value.replace("T", " ");
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      id: "",
      msgDetail: {},
      isRead: [],
      unRead: [],
      fileList:[]
    };
  },
  created() {
    this.id = this.$route.params.id;
        this.readMessage()
  },
  methods: {
    readMessage(){
       axios
        .get(api.doRead + `\\${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("已读", res.data.result);
                this.getDetail()
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    getDetail() {
      // 获取详情
      axios
        .get(api.getNoticeById + `\\${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取通知成功", res.data.result);
            this.msgDetail = res.data.result;
             this.fileList = this.msgDetail.attachment&&(this.msgDetail.attachment).split(',').map(item => {
              let arr = item.split("/")
              return {name:arr[arr.length-1],path:item}
            })
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
      axios
        .get(api.getReadUnread + `\\${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取已读和未读的用户成功", res.data.result);
            this.isRead = res.data.result.isRead;
            this.unRead = res.data.result.unRead;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.read_message {
  .read_message-wrap {
    padding: 77px 30px 0px 30px;
    .read_message-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .read_message-title {
        font-size: 22px;
        padding: 26px 32px 24px 32px;
        border-bottom: 1px solid rgba(230, 227, 227, 1);
      }
      .read_message-detail_wrap {
        padding: 13px 32px 34px 32px;
        .read_message-time {
          display: flex;
          color: #9b9b9b;
          .read_message-table_urgent {
            font-size: 11px;
            color: #fff;
            background: #39b54a;
            width: 28px;
            height: 16px;
            border-radius: 2px;
            text-align: center;
            line-height: 16px;
          }
          .read_message-table_top {
            margin-right: 11px;
            font-size: 8px;
            color: #fff;
            background: #f0722b;
            width: 28px;
            height: 16px;
            border-radius: 2px;
            text-align: center;
            line-height: 16px;
          }
          div {
            &:last-child {
              margin-right: 10px;
            }
          }
        }
        .read_message-detail {
          padding: 13px 0px;
          min-height: 261px;
        }
				.read_message-file_list {
        display: flex;
        padding: 0px 20px 0px 0px;
        flex-wrap: wrap;
        .read_message-file_item {
					cursor: pointer;
          margin-right: 10px;
          border-radius: 4px;
          border: 1px solid rgba(230, 227, 227, 1);
          padding: 11px 15px;
          a{
              cursor: pointer;
                          text-decoration: none;
                          color:#9b9b9b;
            }
        }
      }
        .read_message-read {
          padding: 16px 7px 16px 15px;
					margin-top: 17px;
          &.unread {
            color: #f0722b;
            background: #fff4ee;
          }
					&.read {
						color:#39B54A;
						background: #F3F8F4;
					}
          .read_message-read_list {
            display: flex;
            margin-top: 8px;
            flex-wrap: wrap;
            .read_message-read_item {
              padding: 3px 8px;
              color: #4a4a4a;
              border-radius: 4px;
              border: 1px solid rgba(230, 227, 227, 1);
              background: #fff;
              margin-right: 8px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
